<template>
  <div class="receipt-container">
    <div class="header">
      <div class="logo-container">
        current transaction via
        <img v-if="channelType === 'jazzcash'" src="@/assets/jazzcash-logo.png" alt="Jazzcash Logo" class="channel-logo" />
        <img v-else-if="channelType === 'easypaisa'" src="@/assets/easypaisa-logo.png" alt="Easypaisa Logo" class="channel-logo" />
      </div>
      <div class="details">
        <div>{{ finishTime }}</div>
        <div>Order Id # {{ $route.params.orderId }}</div>
        <div>Channel Order Id Id # {{ channelOrderId }}</div>
      </div>
    </div>
    <h1 class="title">RECEIPT</h1>
    <div class="receipt-content">
      <div class="row">
        <div class="label">Status</div>
        <div class="value" :class="statusClass">{{ status }}</div>
      </div>
      <div class="row">
        <div class="label">Account Type :</div>
        <div class="value">{{ accountType }}</div>
      </div>
      <div class="row">
        <div class="label">Bank :</div>
        <div class="value">{{ bankName }}</div>
      </div>
      <div class="row">
        <div class="label">Account Number :</div>
        <div class="value">{{ accountNumber }}</div>
      </div>
      <div class="row">
        <div class="label">AMOUNT</div>
        <div class="value">{{ amount }} PKR</div>
      </div>
    </div>
    <div class="footer">
      THANK YOU
    </div>
    <div class="footer-note">
      SYSTEM GENERATED RECEIPT
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      finishTime: '',
      channelOrderId: '',
      channelType: '',
      amount: '',
      status: '',
      accountType: '',
      bankName: '',
      accountNumber: ''
    };
  },
  computed: {
    statusClass() {
      if (this.status === 'Payment Successful'){
        return 'status-success';
      }else if (this.status === 'Payment Failed'){
        return 'status-failed';
      }else {
        return 'status-other';
      }
    }
  },
  mounted() {
    this.fetchReceiptData();
  },
  methods: {
    fetchReceiptData() {
      console.log("fetchReceiptData");
      this.axios
          .get("/order/paymentOrderCertificate", {params: {orderId: this.$route.params.orderId}})
          .then(res => {
            this.finishTime = res.finishTime;
            this.channelOrderId = res.channelOrderId;
            this.channelType = res.channelType;
            this.amount = res.amount;
            this.status = res.status;
            this.accountType = res.accountType;
            this.bankName = res.bankName;
            this.accountNumber = res.accountNumber;
      })
    }
  }
};
</script>

<style scoped>
.receipt-container {
  max-width: 600px;
  margin: auto;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  font-family: Arial, sans-serif;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.logo-container {
  margin-bottom: 20px;
  font-size: 10px;
  color: gray;
}

.channel-logo {
  width: 150px;
  display: block;
  margin: 0 auto;
}

.details {
  text-align: right;
}

.title {
  font-size: 24px;
  margin: 20px 0;
  color: #333;
}

.receipt-content {
  text-align: left;
  margin-bottom: 20px;
}

.row {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
}

.label {
  font-weight: bold;
}

.value {
  text-align: right;
}

.status-success {
  color: green;
  font-weight:bold;
}

.status-failed {
  color: red;
  font-weight:bold;
}

.status-other {
  color: blue;
  font-weight:bold;
}

.footer {
  font-size: 20px;
  margin-top: 20px;
  color: green;
}

.footer-note {
  font-size: 12px;
  color: #666;
}
</style>
